import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { ButtonComponent } from '../ButtonComponent';

const options = ['A', 'F'];

export interface AdjustHoursButtonsProps {
    worklogReportState: any;
    instance: any
    showAdjustHours: boolean;
  }
export default function AdjustHoursButtons(props:AdjustHoursButtonsProps) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleClick = () => {
    props.worklogReportState.setReportToAdjust(props.instance);
  };

  React.useEffect(() => {
    props.worklogReportState.setAdjustFixed(selectedIndex != 0);
  },[selectedIndex])

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  const renderOptions = (index: number, option: string) => {
    console.log(props.showAdjustHours)
    if (index === 0 && props.showAdjustHours) {
      return <MenuItem
        key={option}
        selected={index === selectedIndex}
        onClick={(event) => handleMenuItemClick(event, index)}
      >
        {option}
      </MenuItem>
    }
    if (index !== 0) {
      return <MenuItem
        key={option}
        selected={index === selectedIndex}
        onClick={(event) => handleMenuItemClick(event, index)}
      >
        {option}
      </MenuItem>
    }

  }

  return (
    <div style={{height:"1.7rem"}}>
      <ButtonGroup variant="text" ref={anchorRef} aria-label="split button" style={{height:"1.7rem", padding:5}} size="small">
        <ButtonComponent
            debounce={true}
            onClick={handleClick}
            text={options[selectedIndex]}
            style={{minWidth:"1.125rem", maxWidth:"1.125rem", margin:"0% 10%", paddingRight:"10%", height:"100%"}}
        />
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          style={{minWidth:"1.125rem", maxWidth:"1.125rem", margin:"0% 10%", height:"100%"}}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        style={{
          zIndex: 999,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    renderOptions(index, option)
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}